import { loadStripe } from '@stripe/stripe-js/pure';

let loaded;

// Stripe.js has to come from js.stripe.com, so an ad blocker or a corporate proxy can keep it out.
// A failed load resolves to null and is not kept, so the next booking attempt loads again.
const loadTourStripe = (publishableKey) => {
  if (!publishableKey) {
    return Promise.resolve(null);
  }

  if (!loaded || loaded.publishableKey !== publishableKey) {
    const stripe = loadStripe(publishableKey).catch(() => {
      loaded = undefined;
      return null;
    });
    loaded = { publishableKey, stripe };
  }

  return loaded.stripe;
};

export default loadTourStripe;
